import React from 'react'
import * as S from './styles'
import { MdxWrapperProps } from '../../wrapper/src/types'

/*
  This component should be used to wrap a markdown-rendering component that will
  render legal content. It formats legal nested bullet-ing correctly:
  (1,2,3... --> 1.1,1.2,1.3... --> (a),(b),(c)...)
 */
const LegalMdxWrapper: React.FC<MdxWrapperProps> = ({ children, ...rest }) => (
  <S.Wrapper {...rest}>{children}</S.Wrapper>
)

export default LegalMdxWrapper
